import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useStore = defineStore('store', () => {
  const pitchKey = ref('about')
  function changeKey(newKey) {
    pitchKey.value = newKey
  }
  return { pitchKey, changeKey }
})
